<template>
  <booking-block
    class="booking-block--payment-details"
    :valid="!validForm"
    :title="translations.header"
    :subTitle="subHeader"
    :editMode="editMode"
    @save="saveAndClose"
    @edit="$emit('edit')"
    ref="bookingblock"
  >
    <template slot="edit">
      <div class="booking-table">
        <div class="booking-table__row" v-if="price !== null">
          <span class="booking-table__col" v-text="translations.price"></span>
          <span class="booking-table__col"
            >€<span v-price="price"></span> EUR</span
          >
        </div>
        <div class="booking-table__row" v-if="feeEur !== null">
          <span
            class="booking-table__col"
            v-text="translations.price_tax"
          ></span>
          <span class="booking-table__col"
            >€<span v-price="feeEur"></span> EUR</span
          >
        </div>
        <div class="booking-table__row" v-if="totalPrice !== null">
          <span
            class="booking-table__col booking-table__col--bold"
            v-text="translations.price_total"
          ></span>
          <span class="booking-table__col booking-table__col--bold"
            >€<span v-price="totalPrice"></span> EUR</span
          >
        </div>
        <div class="label-checkbox booking-confirm">
          <input
            type="checkbox"
            id="confirm"
            :checked="value ? true : false"
            @change="
              (evt) => {
              $emit('input', evt.target.checked ? true : false);
            }
            "
          />
          <label for="confirm" class="label">
            <span class="label-checkbox__circle"></span>
            <span class="label-checkbox__check"></span>
            <span class="label-checkbox__box"></span>
            {{ translations.accept_terms }}
            <span class="confirm-list">
              <span class="confirm-list__item" v-if="conditionsDocument"
                ><a
                  :href="conditionsDocument.url"
                  target="_blank"
                  v-text="
                    translations.condition.conditions.replace(
                    /{tour_oprerator}/,
                    tourOperator
                  )
                  "
                ></a
              ></span>
              <span
                class="confirm-list__item"
                v-text="translations.condition.terms"
              ></span>
              <span class="confirm-list__item" v-if="formDocument"
                ><a
                  target="_blank"
                  :href="formDocument.url"
                  v-text="translations.condition.form_docuemnt"
                ></a
              ></span>
              <span class="confirm-list__item" v-if="visaDocumnet"
                ><a
                  target="_blank"
                  :href="visaDocumnet.url"
                  v-text="translations.condition.visa"
                ></a
              ></span>
            </span>
          </label>
        </div>
        <msg-block v-if="errors.terms" type="error">
          <p>
            <b
              v-for="(errorTxt, errorKey) in errors.terms"
              v-text="errorTxt"
              :key="errorKey"
            ></b>
          </p>
        </msg-block>
        <div>
          <div class="label-checkbox booking-confirm" v-if="hasChanges">
            <input
              type="checkbox"
              :checked="acceptChanges ? true : false"
              id="confirm-changes"
              :disabled="loading"
              @change="
                (evt) =>
                $emit('acceptChanges', evt.target.checked ? true : false)
              "
            />
            <label for="confirm-changes" class="label">
              <span class="label-checkbox__circle"></span>
              <span class="label-checkbox__check"></span>
              <span class="label-checkbox__box"></span>
              {{ translations.change_notice_txt }}
              <span class="confirm-list">
                <span
                  class="confirm-list__item"
                  v-for="(changedTxt, changedKey) in filteredChangeList"
                  v-html="changedTxt"
                  :key="changedKey"
                ></span>
              </span>
            </label>
          </div>
          <msg-block v-if="errors.changes" type="error">
            <p
              v-for="(errorTxt, errorKey) in errors.changes"
              v-text="errorTxt"
              :key="errorKey"
            ></p>
          </msg-block>
        </div>
      </div>
    </template>
    <template slot="view">
      <div class="booking-table">
        <div class="booking-table__row" v-if="price !== null">
          <span class="booking-table__col" v-text="translations.price"></span>
          <span class="booking-table__col"
            >€<span v-price="price"></span> EUR</span
          >
        </div>
        <div class="booking-table__row" v-if="feeEur !== null">
          <span
            class="booking-table__col"
            v-text="translations.price_tax"
          ></span>
          <span class="booking-table__col"
            >€<span v-price="feeEur"></span> EUR</span
          >
        </div>
        <div class="booking-table__row" v-if="totalPrice !== null">
          <span
            class="booking-table__col booking-table__col--bold"
            v-text="translations.price_total"
          ></span>
          <span class="booking-table__col booking-table__col--bold"
            >€<span v-price="totalPrice"></span> EUR</span
          >
        </div>
      </div>
      <div class="label-checkbox booking-confirm">
        <input
          type="checkbox"
          id="confirm"
          :checked="value ? true : false"
          :disabled="true"
        />
        <label for="confirm" class="label">
          <span class="label-checkbox__circle"></span>
          <span class="label-checkbox__check"></span>
          <span class="label-checkbox__box"></span>
          {{ translations.accept_terms }}
          <span class="confirm-list">
            <span class="confirm-list__item" v-if="conditionsDocument"
              ><a
                :href="conditionsDocument.url"
                target="_blank"
                v-text="
                  translations.condition.conditions.replace(
                  /{tour_oprerator}/,
                  tourOperator
                )
                "
              ></a
            ></span>
            <span
              class="confirm-list__item"
              v-text="translations.condition.terms"
            ></span>
            <span class="confirm-list__item" v-if="formDocument"
              ><a
                target="_blank"
                :href="formDocument.url"
                v-text="translations.condition.form_docuemnt"
              ></a
            ></span>
            <span class="confirm-list__item" v-if="visaDocumnet"
              ><a
                target="_blank"
                :href="visaDocumnet.url"
                v-text="translations.condition.visa"
              ></a
            ></span>
          </span>
        </label>
      </div>
      <div class="label-checkbox booking-confirm" v-if="hasChanges">
        <input
          type="checkbox"
          :checked="acceptChanges ? true : false"
          id="confirm-changes"
          :disabled="true"
        />
        <label for="confirm-changes" class="label">
          <span class="label-checkbox__circle"></span>
          <span class="label-checkbox__check"></span>
          <span class="label-checkbox__box"></span>
          {{ translations.change_notice_txt }}
          <span class="confirm-list">
            <span
              class="confirm-list__item"
              v-for="(changedTxt, changedKey) in filteredChangeList"
              v-html="changedTxt"
              :key="changedKey"
            ></span>
          </span>
        </label>
      </div>
    </template>

    <template slot="footer">
      <div class="booking-block__footer__attention" v-if="notice">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M20.57,24.8c0,.19-.15,.34-.34,.34H11.77c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h1.95v-8h-1.95c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h6.18c.19,0,.34,.15,.34,.34v9.95h1.95c.19,0,.34,.15,.34,.34v1.61ZM16,5.66c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34Zm0-5.66C7.16,0,0,7.17,0,16s7.16,16,16,16,16-7.17,16-16S24.84,0,16,0Z"/>
          </svg>
        </div>
        <p v-text="notice"></p>
      </div>
      <div class="booking-block__footer__attention" v-if="priceNoticeTxt">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M20.57,24.8c0,.19-.15,.34-.34,.34H11.77c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h1.95v-8h-1.95c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h6.18c.19,0,.34,.15,.34,.34v9.95h1.95c.19,0,.34,.15,.34,.34v1.61ZM16,5.66c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34Zm0-5.66C7.16,0,0,7.17,0,16s7.16,16,16,16,16-7.17,16-16S24.84,0,16,0Z"/>
          </svg>
        </div>
        <p v-text="priceNoticeTxt"></p>
      </div>
    </template>
  </booking-block>
</template>

<script>
import MsgBlock from "../msg-block.vue";
import currencyFormatter from "currency-formatter";
import Moment from "moment";
import _ from "underscore";
import BookingBlock from "./booking-block.vue";

export default {
  props: {
    editMode: { type: Boolean, default: true },
    value: { type: Boolean, default: false },
    changes: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    acceptChanges: { type: Boolean, default: false },
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.BOOKING_PAYMENT_DETAILS,
      showErrors: false,
      errors: {},
      loading: false
    };
  },
  watch: {
    validForm() {
      if (this.showErrors) {
        this.updateErrors();
      }

      this.$emit("valid", !this.validForm ? true : false);
    },
    changes() {
      if (this.hasChanges) {
        this.$emit("acceptChanges", false);
      }
    },
    acceptChanges() {
      if(this.acceptChanges) {
        this.onAcceptedChanges();
      }
    }
  },
  methods: {
    showValidationErrors() {
      this.showErrors = true;
      this.updateErrors();
    },
    hideValidationErrors() {
      this.showErrors = false;
      this.errors = {};
    },
    updateErrors() {
      this.errors = Object.assign({}, this.validForm);
    },
    saveAndClose() {
      if (this.validForm === null) {
        this.hideValidationErrors();
            this.$nextTick(() => {
              this.$refs.bookingblock.close();
            });
      } else {
        this.showValidationErrors();
      }
    },
    onAcceptedChanges() {
      if(this.changes.filter(({type}) => type == 'price').length) {
        return this.onUserPriceConsent();
      }

      return Promise.resolve();
    },
    onUserPriceConsent() {
      this.loading = true;
        return this.$store
        .dispatch("updateBookingDraft", {
          draftId: this.$route.params.draftid,
          params: {
            userConsentedToPriceChange: this.acceptChanges ? true : false
          }
        })
        .then(() => {
          this.loading = false;
          this.$emit('userConsentedPrice');
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
          this.$nextTick(() => {
            this.$emit("acceptChanges", false);
          });
        });
    },
  },
  computed: {
    notice() {
      let price = currencyFormatter.format(this.totalPrice, {
        symbol: "EUR",
        thousand: ".",
        decimal: ",",
        precision: 0,
        format: "%v %s",
      });

      let danish_price = currencyFormatter.format(this.totalPriceDKK, {
        symbol: "DKK",
        thousand: ".",
        decimal: ",",
        precision: 0,
        format: "%v %s",
      });

      return this.translations.notice
        .replace(/{price}/, price)
        .replace(/{danish_price}/, danish_price);
    },
    priceNoticeTxt() {
      let depositPrice = _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "paymentInformation",
        "deposit",
        "price",
        "value",
      ]);
      let depositPriceCurr = _.propertyOf(
        this.$store.state.selectedBookingOffer
      )([
        "verifiedOffer",
        "paymentInformation",
        "deposit",
        "price",
        "currency",
      ]);

      if (!depositPrice) {
        return null;
      }

      let paymentDate = _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "paymentInformation",
        "deposit",
        "term",
      ]);
      let finalDate = _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "paymentInformation",
        "final",
        "term",
      ]);
      let finalPrice = _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "paymentInformation",
        "final",
        "price",
        "value",
      ]);

      depositPrice = depositPrice
        ? currencyFormatter.format(depositPrice, {
          symbol: depositPriceCurr,
          thousand: ".",
          decimal: ",",
          precision: 2,
          format: "%v %s",
        })
        : "";

      paymentDate = paymentDate
        ? Moment(paymentDate, "YYYY-MM-DD").format("DD.MM.YYYY")
        : null;

      if (!finalPrice) {
        return paymentDate
          ? this.translations.price_notice_text_onlydeposit
            .replace(/{deposit_price}/, depositPrice)
            .replace(/{payment_date}/, paymentDate)
          : this.translations.price_notice_text_onlydeposit_no_payment_date.replace(
            /{deposit_price}/,
            depositPrice
          );
      }

      finalDate = finalDate
        ? "d." + Moment(finalDate, "YYYY-MM-DD").format("DD.MM.YYYY")
        : this.translations.no_deposit_final_date_txt;
      return paymentDate
        ? this.translations.price_notice_text
          .replace(/{deposit_price}/, depositPrice)
          .replace(/{payment_date}/, paymentDate)
          .replace(/{final_payment_date}/, finalDate)
        : this.translations.price_notice_text_no_payment_date
          .replace(/{deposit_price}/, depositPrice)
          .replace(/{final_payment_date}/, finalDate);
    },
    price() {
      return _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "packageOffer",
        "totalPriceEuro",
        "value",
      ]);
    },
    feeEur() {
      //TODO We don't longer know the payment selection
      return null;
    },
    totalPrice() {
      let fee = this.feeEur ? this.feeEur : 0;
      return this.price + fee;
    },
    priceDKK() {
      return _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "packageOffer",
        "totalPrice",
        "value",
      ]);
    },
    feeDKK() {
      //TODO We don't longer know the payment selection
      return null;
    },
    totalPriceDKK() {
      let fee = this.feeDKK ? this.feeDKK : 0;
      return this.priceDKK + fee;
    },
    tourOperator() {
      try {
        return (
          this.$store.state.selectedBookingOffer.verifiedOffer.packageOffer
            .tourOperator.name || ""
        );
      } catch (e) {
        return "";
      }
    },
    conditionsDocument() {
      let doc = this.termDocuments.filter((doc) => doc.type === "conditions");
      if (doc.length) {
        return doc[0];
      }

      return null;
    },
    termDocuments() {
      try {
        return this.$store.state.selectedBookingOffer.documents || [];
      } catch (e) {
        return [];
      }
    },
    visaDocumnet() {
      let doc = this.termDocuments.filter((doc) => doc.type === "visa");
      if (doc.length) {
        return doc[0];
      }

      return null;
    },
    formDocument() {
      let doc = this.termDocuments.filter((doc) => doc.type === "form");
      if (doc.length) {
        return doc[0];
      }

      return null;
    },
    hasChanges() {
      return !_.isEmpty(this.changes) ? true : false;
    },
    validForm() {
      let errors = {};

      if (!this.value) {
        errors["terms"] = [this.translations.ERRORS.missing_terms];
      }

      if (this.hasChanges && !this.acceptChanges) {
        errors["changes"] = [this.translations.ERRORS.missing_changes];
      }

      return !_.isEmpty(errors) ? errors : null;
    },
    subHeader() {
      if (this.validForm === null) {
        return currencyFormatter.format(this.totalPrice, {
          symbol: "EUR",
          thousand: ".",
          decimal: ",",
          precision: 0,
          format: "%v %s",
        });
      }

      return this.translations.sub_header;
    },
    filteredChangeList() {
      return this.changes.filter(({ type }) => {
        return ['departureDate', 'homeAgainDate', 'inboundStops', 'outboundStops'].indexOf(type) <= -1 ? true : false;
      }).map(({ text }) => text);
    }
  },
  components: {
    MsgBlock,
    BookingBlock,
  },
};
</script>

